// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont-search-relation-RelationTechDevice .inputSearch{
    background-color: #0166a0 !important;
}
.cont-search-relation-RelationTechDevice .inputSearch:focus, .cont-search-relation-RelationTechDevice .inputSearch:hover {
    
    color: aliceblue !important;
  }
.body_info_cis_relation {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .cont-RelationTechDevice-table-relation {
    position: relative;
    height: 90%;
    width: 100%;
    /* background: rgba(195,195,195);
    background: #003757; */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .card-users.modal-verificate{
    width: 100% !important;
    height: 99% !important;
}

.txt-title-user-box-RelationTechDevice.modal-verificate{
    text-align: center;
    word-wrap: break-word;
    width: 80%;
}
.user-box-RelationTechDevice{
    height: 10% !important;
}
.user-box-RelationTechDevice {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 20%;
}
.form-RelationTechDevice-box {
    position: relative;
    display: block;
    width: 80%;
    height: 90%;
  }
.form-RelationTechDevice-box .user-box-RelationTechDevice .label-RelationTechDevice {
    position: absolute;
    top: 0px !important;
    left: 0;
    padding: 10px 0;
    font-size: 10px !important;
    font-weight: bolder;
    color: #003757;
    pointer-events: none;
    transition: .5s;
  }
  .form-RelationTechDevice-box .user-box-RelationTechDevice input:focus ~ .label-RelationTechDevice, .form-RelationTechDevice-box .user-box-RelationTechDevice input:valid ~ .label-RelationTechDevice {
    top: -25px !important;
    left: 0px;
    color: #003757;
    font-size: 12px;
  }



  
  .form-RelationTechDevice-box .user-box-RelationTechDevice input:focus ~ .label-RelationTechDevice,
.form-RelationTechDevice-box .user-box-RelationTechDevice input:valid ~ .label-RelationTechDevice,
.form-RelationTechDevice-box .user-box-RelationTechDevice .active {
    top: -25px !important;
    left: 0px;
    font-size: 12px;
}


.form-RelationTechDevice-box .user-box-RelationTechDevice input {
  width: 100%;
  padding: 10px 0;
  font-size: 16px;
  color: #505050;
  margin-bottom: 30px;
  border: none;
  border-bottom: 2px solid #003757;
  border-right: 2px solid #003757;
  outline: none;
  background: transparent;
}

.form-RelationTechDevice-box .user-box-RelationTechDevice input:focus ~ .label-RelationTechDevice,
.form-RelationTechDevice-box .user-box-RelationTechDevice input:valid ~ .label-RelationTechDevice {
  top: -10px;
  left: 0;
  color: #003757;
  font-size: 12px;
}
.form-msg-error{
  color: #ff4646;
  position: absolute;
  left:0;
  /* top:10% */
  bottom: 5%;
  background-color: rgba(255, 211, 211, 0.64);
  width: 99%;
  text-align: center;
  border: 2px solid #ff4646;
  border-radius: 0px 0px 5px 5px;
  
  border-top: none;

}
.head-card-RelationTechDevice {
  position: relative;
  height: 5%;
  width: 100%;
  background: rgba(195,195,195);
  background: #003757;
  display: flex;
  justify-content: center;
  align-items: center;
}
  .content-RelationTechDevice_relation {
    position: relative;
    justify-content: center;
    display: block;
    height: 98%;
    width: 94%;
    border-radius: 10px;
    /* box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15); */
    /* border: 2px solid #003757; */
    border-radius: 10px;
  }

  .cont-search-relation-RelationTechDevice {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 35%;
  }
  
  .content-card-RelationTechDevice-relation {
    position: relative;
    height: 100%;
    width: 100%;
    display: block;
    justify-content: center;
    align-items: center;
    border: 1px solid #003757;
    border-radius: 10px;
  }

  .cont-elemen-relation{
    position: relative;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;

  }
  .elemen-relation{
    position: relative;
    width: 85%;
    height: 70%;
    border-radius: 10px;
    border:2px solid #003757;
    display: flex;

  }

  .con-elemen-relation-info{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    height: 100%;
    color: #003757;
  }
  .con-elemen-relation-img{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 10%;
    height: 100%;
  }
  .img-relation:hover{
    cursor: pointer;
  }
  .msgErrorRelation{
    color: red;
  }
  .cont-RelationTechDevice-info{
    height: 32%;
  width: 100%;
  /* background: rgba(195,195,195); */
  /* background: #003757; */
  display: block;
  justify-content: center;
  align-items: center;
  }
  .row-RelationTechDevice-info{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 33.33%;
  }
  .cont-title-RelationTechDevice-info{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 35%;
    height: 100%;
  }
  .cont-box-RelationTechDevice-info{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 65%;
    height: 100%;
  }
  .box-RelationTechDevice-info{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 95%;
    height: 80%;
    border-radius: 10px;
    background-color: #dfdfdf;
    color: #505050;
  }
  .title-RelationTechDevice-info{
    position: relative;
    display: flex;
    justify-content: left;
    align-items: center;
    width: 95%;
    height: 80%;
    text-align: left;
    color: #003757;
  }

  .user-box-RelationTechDevice button{
    height: 3vh !important;
  }
  .cont-RelationTechDevice-search{
    display: flex;
    height: 8%;

  }`, "",{"version":3,"sources":["webpack://./src/components/portafolio-components/styles/ModalTechDevice.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;AACA;;IAEI,2BAA2B;EAC7B;AACF;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX;0BACsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,sBAAsB;AAC1B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;EACb;AACF;IACI,kBAAkB;IAClB,mBAAmB;IACnB,OAAO;IACP,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,SAAS;IACT,cAAc;IACd,eAAe;EACjB;;;;;EAKA;;;IAGE,qBAAqB;IACrB,SAAS;IACT,eAAe;AACnB;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;EACV,OAAO;EACP,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;;EAE9B,gBAAgB;;AAElB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;EACE;IACE,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,2FAA2F;IAC3F,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;EAErB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,wBAAwB;IACxB,aAAa;;EAEf;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb,WAAW;EACX,mCAAmC;EACnC,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,UAAU;;EAEZ","sourcesContent":[".cont-search-relation-RelationTechDevice .inputSearch{\r\n    background-color: #0166a0 !important;\r\n}\r\n.cont-search-relation-RelationTechDevice .inputSearch:focus, .cont-search-relation-RelationTechDevice .inputSearch:hover {\r\n    \r\n    color: aliceblue !important;\r\n  }\r\n.body_info_cis_relation {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n  .cont-RelationTechDevice-table-relation {\r\n    position: relative;\r\n    height: 90%;\r\n    width: 100%;\r\n    /* background: rgba(195,195,195);\r\n    background: #003757; */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .card-users.modal-verificate{\r\n    width: 100% !important;\r\n    height: 99% !important;\r\n}\r\n\r\n.txt-title-user-box-RelationTechDevice.modal-verificate{\r\n    text-align: center;\r\n    word-wrap: break-word;\r\n    width: 80%;\r\n}\r\n.user-box-RelationTechDevice{\r\n    height: 10% !important;\r\n}\r\n.user-box-RelationTechDevice {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 20%;\r\n}\r\n.form-RelationTechDevice-box {\r\n    position: relative;\r\n    display: block;\r\n    width: 80%;\r\n    height: 90%;\r\n  }\r\n.form-RelationTechDevice-box .user-box-RelationTechDevice .label-RelationTechDevice {\r\n    position: absolute;\r\n    top: 0px !important;\r\n    left: 0;\r\n    padding: 10px 0;\r\n    font-size: 10px !important;\r\n    font-weight: bolder;\r\n    color: #003757;\r\n    pointer-events: none;\r\n    transition: .5s;\r\n  }\r\n  .form-RelationTechDevice-box .user-box-RelationTechDevice input:focus ~ .label-RelationTechDevice, .form-RelationTechDevice-box .user-box-RelationTechDevice input:valid ~ .label-RelationTechDevice {\r\n    top: -25px !important;\r\n    left: 0px;\r\n    color: #003757;\r\n    font-size: 12px;\r\n  }\r\n\r\n\r\n\r\n  \r\n  .form-RelationTechDevice-box .user-box-RelationTechDevice input:focus ~ .label-RelationTechDevice,\r\n.form-RelationTechDevice-box .user-box-RelationTechDevice input:valid ~ .label-RelationTechDevice,\r\n.form-RelationTechDevice-box .user-box-RelationTechDevice .active {\r\n    top: -25px !important;\r\n    left: 0px;\r\n    font-size: 12px;\r\n}\r\n\r\n\r\n.form-RelationTechDevice-box .user-box-RelationTechDevice input {\r\n  width: 100%;\r\n  padding: 10px 0;\r\n  font-size: 16px;\r\n  color: #505050;\r\n  margin-bottom: 30px;\r\n  border: none;\r\n  border-bottom: 2px solid #003757;\r\n  border-right: 2px solid #003757;\r\n  outline: none;\r\n  background: transparent;\r\n}\r\n\r\n.form-RelationTechDevice-box .user-box-RelationTechDevice input:focus ~ .label-RelationTechDevice,\r\n.form-RelationTechDevice-box .user-box-RelationTechDevice input:valid ~ .label-RelationTechDevice {\r\n  top: -10px;\r\n  left: 0;\r\n  color: #003757;\r\n  font-size: 12px;\r\n}\r\n.form-msg-error{\r\n  color: #ff4646;\r\n  position: absolute;\r\n  left:0;\r\n  /* top:10% */\r\n  bottom: 5%;\r\n  background-color: rgba(255, 211, 211, 0.64);\r\n  width: 99%;\r\n  text-align: center;\r\n  border: 2px solid #ff4646;\r\n  border-radius: 0px 0px 5px 5px;\r\n  \r\n  border-top: none;\r\n\r\n}\r\n.head-card-RelationTechDevice {\r\n  position: relative;\r\n  height: 5%;\r\n  width: 100%;\r\n  background: rgba(195,195,195);\r\n  background: #003757;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n  .content-RelationTechDevice_relation {\r\n    position: relative;\r\n    justify-content: center;\r\n    display: block;\r\n    height: 98%;\r\n    width: 94%;\r\n    border-radius: 10px;\r\n    /* box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15); */\r\n    /* border: 2px solid #003757; */\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .cont-search-relation-RelationTechDevice {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n    width: 35%;\r\n  }\r\n  \r\n  .content-card-RelationTechDevice-relation {\r\n    position: relative;\r\n    height: 100%;\r\n    width: 100%;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border: 1px solid #003757;\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .cont-elemen-relation{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 60px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n  }\r\n  .elemen-relation{\r\n    position: relative;\r\n    width: 85%;\r\n    height: 70%;\r\n    border-radius: 10px;\r\n    border:2px solid #003757;\r\n    display: flex;\r\n\r\n  }\r\n\r\n  .con-elemen-relation-info{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 90%;\r\n    height: 100%;\r\n    color: #003757;\r\n  }\r\n  .con-elemen-relation-img{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 10%;\r\n    height: 100%;\r\n  }\r\n  .img-relation:hover{\r\n    cursor: pointer;\r\n  }\r\n  .msgErrorRelation{\r\n    color: red;\r\n  }\r\n  .cont-RelationTechDevice-info{\r\n    height: 32%;\r\n  width: 100%;\r\n  /* background: rgba(195,195,195); */\r\n  /* background: #003757; */\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  }\r\n  .row-RelationTechDevice-info{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 33.33%;\r\n  }\r\n  .cont-title-RelationTechDevice-info{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 35%;\r\n    height: 100%;\r\n  }\r\n  .cont-box-RelationTechDevice-info{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 65%;\r\n    height: 100%;\r\n  }\r\n  .box-RelationTechDevice-info{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 95%;\r\n    height: 80%;\r\n    border-radius: 10px;\r\n    background-color: #dfdfdf;\r\n    color: #505050;\r\n  }\r\n  .title-RelationTechDevice-info{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: left;\r\n    align-items: center;\r\n    width: 95%;\r\n    height: 80%;\r\n    text-align: left;\r\n    color: #003757;\r\n  }\r\n\r\n  .user-box-RelationTechDevice button{\r\n    height: 3vh !important;\r\n  }\r\n  .cont-RelationTechDevice-search{\r\n    display: flex;\r\n    height: 8%;\r\n\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
